import React, {Component} from 'react'
import {Modal, Form, Row, Col, Input, Select, Button} from 'antd'
import groovyManagementAPI from '../../../apis/groovyManagement'
import {withTranslation} from 'react-i18next'

const {TextArea} = Input

class FormModal extends Component {
  formRef = React.createRef()
  state = {}

  componentDidMount() {
    const {id} = this.props
    groovyManagementAPI.ViewInfoAction(id).then(res => {
      let result = res.data.data
      this.formRef.current.setFieldsValue({
        name: result.name,
        client: result.client,
        script: result.script,
      })
    })
  }

  render() {
    const {viewModalVisible, handleViewCancel, t} = this.props
    return (
      <>
        <Modal
          title={`${t(`general.add`)} ${t(`groovyManagement.groovy`)}`}
          width="70%"
          closable={true}
          onCancel={() => { handleViewCancel('viewModalVisible') }}
          visible={viewModalVisible}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Cancel" onClick={() => { handleViewCancel('viewModalVisible') }}>Close</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addMapping" layout="vertical">
            <Row justify="start" gutter={[10, 10]}>
              <Col span={10}>
                <Form.Item name="name" label={t(`groovyManagement.name`)}>
                  <Input maxLength={100} disabled placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>

              <Col span={10}>
                <Form.Item name="client" label={t(`groovyManagement.module`)}>
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear disabled>
                    <Select.Option key="DataSource" value="DATASOURCE">DataSource</Select.Option>
                    <Select.Option key="DataTarget" value="DATATARGET">DataTarget</Select.Option>
                    <Select.Option key="InBoundAPI" value="INBOUNDAPI">InBound API</Select.Option>
                    <Select.Option key="OutBoundAPI" value="OUTBOUNDAPI">OutBound API</Select.Option>
                    <Select.Option key="Mapping" value="MAPPING">Mapping</Select.Option>
                    <Select.Option key="Mappingpre" value="MAPPINGPRE">Mapping pre</Select.Option>
                    <Select.Option key="Mappingpost" value="MAPPINGPOST">Mapping post</Select.Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item name="script" label={t(`groovyManagement.script`)}>
                  <TextArea rows={10} disabled/>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
